export default __webpack_public_path__ + "static/media/med-school.b6707c9f.png";